(function() {
	'use strict';

	angular.module('taskApp').factory('MyTask', MyTask);

	MyTask.$inject = [ '$resource' ];

	function MyTask($resource) {
		var resourceUrl = GLOBAL_URL+'api/wf/my-task';
		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                transformResponseError: function(error){
                	if(error.status === 0){
                		alert('There is a problem connecting to the server. Is the server probably down?!');
                	}
                	 return $q.reject(error);
                }
			},
			'release' : {
				method : 'GET',
				url : GLOBAL_URL+'api/wf/release-task'
			},
		});
	}
})();